import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        title: "Vigolive唯果租房 ：找直租，上唯果和房东聊",
      },
      component: () => import("@/pages/HomePage.vue"),
    },
    {
      path: "/qa",
      name: "qa",
      
      component: () => import("@/pages/QAPage.vue"),
    },
    {
      path: "/aboutus",
      name: "aboutus",
      component: () => import("@/pages/AboutUsPage.vue"),
    },
    {
      path: "/download",
      name: "download",
      component: () => import("@/pages/DownloadPage.vue"),
    },
    {
      path: "/user-license",
      name: "user-license",
      component: () => import("@/pages/UserLicensePage.vue"),
    },{
      path: "/privacy",
      name: "privacy",
      component: () => import("@/pages/PrivacyPage.vue"),
    },
    
    
  ],
});

router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "唯果租房";
  }
  next();
})

export default router;
